import { lazyModuleMethod } from '@/helpers/lazyModuleMethod'

export const test = {
  createTest: lazyModuleMethod(() => import('./createTest'), 'default'),
  deleteTest: lazyModuleMethod(() => import('./deleteTest'), 'default'),
  fetchTests: lazyModuleMethod(() => import('./fetchTests'), 'default'),
  fetchTest: lazyModuleMethod(() => import('./fetchTest'), 'default'),
  editTest: lazyModuleMethod(() => import('./editTest'), 'default'),
  createTestResult: lazyModuleMethod(
    () => import('./createTestResult'),
    'default'
  ),
  createTestQuestion: lazyModuleMethod(
    () => import('./createTestQuestion'),
    'default'
  ),
  createTestQuestionAnswer: lazyModuleMethod(
    () => import('./createTestQuestionAnswer'),
    'default'
  ),
  deleteTestResult: lazyModuleMethod(
    () => import('./deleteTestResult'),
    'default'
  ),
  deleteTestQuestion: lazyModuleMethod(
    () => import('./deleteTestQuestion'),
    'default'
  ),
  deleteTestQuestionAnswer: lazyModuleMethod(
    () => import('./deleteTestQuestionAnswer'),
    'default'
  ),
  editTestResult: lazyModuleMethod(() => import('./editTestResult'), 'default'),
  editTestQuestion: lazyModuleMethod(
    () => import('./editTestQuestion'),
    'default'
  ),
  editTestQuestionAnswer: lazyModuleMethod(
    () => import('./editTestQuestionAnswer'),
    'default'
  ),
}
